/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Created_At_LabelInputs */

const en_admin_user_detail_created_at_label = /** @type {(inputs: Admin_User_Detail_Created_At_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account created:`)
};

const de_admin_user_detail_created_at_label = /** @type {(inputs: Admin_User_Detail_Created_At_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account erstellt:`)
};

/**
* | output |
* | --- |
* | "Account created:" |
*
* @param {Admin_User_Detail_Created_At_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_created_at_label = /** @type {((inputs?: Admin_User_Detail_Created_At_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Created_At_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_created_at_label(inputs)
	return en_admin_user_detail_created_at_label(inputs)
});